import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box, Button } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import themeStyles from './SpecialOfferCard.styles';
const CTAContainer = themeStyles.apply(Box, 'CTAContainer');
const BtnWrapper = themeStyles.apply(Box, 'BtnWrapper');
const StyledButton = themeStyles.apply(Button, 'StyledButton');
const CTAs = ({ ctas }) => {
    const { t } = useTranslation();
    const [primaryCta, secondaryCta] = ctas;
    return (_jsx(CTAContainer, { children: _jsxs(BtnWrapper, { children: [_jsx(StyledButton, { as: "a", href: primaryCta === null || primaryCta === void 0 ? void 0 : primaryCta.link, styling: "primary", children: t('Pages.SpecialOffers.checkInventoryButton') }), _jsx(StyledButton, { as: "a", href: secondaryCta === null || secondaryCta === void 0 ? void 0 : secondaryCta.link, styling: "secondary", children: t('Shared.Common.buildAndPriceButton') })] }) }));
};
export default CTAs;
